import {isMobile} from "react-device-detect";
//uniPAY NEXT
import TransactionReport from "reports/TransactionReport.jsx";
import SettlementReport from "reports/SettlementReport.jsx";
import EmiReport from "reports/EmiReport.jsx";
import AcquirerReport from "reports/AcquirerReport.jsx";
import Sale from "reports/Sale.jsx";
import AnyCardEmi from "anycardemi/AnyCardEmi.jsx";
import UploadExcel from "views/UploadExcel.jsx";
import AuditLog from "views/AuditLog.jsx";
import FlatFiles from "components/FlatFiles/FlatFiles.jsx";
import InternalReport from "reports/InternalReport.jsx"
import Support from "reports/Support.jsx"
import UserList from "views/UserList.jsx";
import DashboardList from "components/Dashboard/DashboardList.jsx";
import AdminInvoice from "views/AdminInvoice.jsx";
import SchedularReportPage from "views/SchedularReportPage";
import TableauSettings from "tableau/TableauSettings.jsx";
import TableauDataMgt from "tableau/TableauDataMgt.jsx";
import TableauProject from "tableau/TableauProject.jsx";
import LoungeProject from "tableau/LoungeProject.jsx";
import LoungeProject1 from "tableau/LoungeProject1.jsx";
import DmsProject from "tableau/DmsProject.jsx"
import JobMgt from "views/JobMgt.jsx";
import TableauReportAccessPermission from "tableau/TableauReportAccessPermission.jsx";
import AxisAggrMaster from "views/AxisAggrMaster.jsx"
import AdaniGasStationDailyReport from "components/AdaniReports/AdaniGasStationDailyReport.jsx";
import SSISProcessLogs from "views/SSISProcessLogs.jsx"
import CampaignLists from "components/CampaignModule/CampaignLists.jsx";

//IPOS Menus
import IposDashboard from "ipos/IposDashboard.jsx";
import IposTrends from "ipos/IposTrends.jsx";
import IposTools from "ipos/IposTools.jsx";
import IposHelp from "ipos/IposHelp.jsx";
import IposProfile from "ipos/IposProfile.jsx";


//diy Brand EMi
import BrandEMIAdmin from "brandemi/BrandEMIAdmin.jsx"
import Onboarding from "brandemi/Onboarding.jsx";
import BrandEmiReport from "brandemi/BrandEmiReport.jsx";
import Communication from "brandemi/Communication.jsx";

//diy Integration
import Home from "diyComponents/Home.jsx";
import ApiHome from "diyComponents/ApiHome.jsx";
import DiyTransactionReport from "diyComponents/TransactionReport.jsx";
import IntegrationKey from "diyComponents/IntegrationKey.jsx";
import TerminalSimulator from "diyComponents/TerminalSimulator.jsx";

//Inventory management
import Order from "inventory/Order.jsx";
import ManageStock from "inventory/ManageStock.jsx";
import Asset from "inventory/Asset.jsx";
import Consumable from "inventory/Consumable.jsx";
import OrderPlacement from "inventory/OrderPlacement.jsx";
import DisputeForm from "inventory/DisputeOrder.jsx";
import tvsStock from "inventory/tvsStock";
import tvsOrder from "./inventory/tvsOrder";
import tvsAsset from "./inventory/tvsAsset";

//Customer Support
import CreateSupportTicket from '../src/customerSupport/CreateSupportTicket';
import ViewTicketStatus from '../src/customerSupport/ViewTicketStatus';
import SupportTicketSummary from '../src/customerSupport/SupportTicketSummary';
import InnovitiSupportModes from '../src/customerSupport/InnovitiSupportModes';
import CustomerSupportDashboard from '../src/customerSupport/Dashboard'
//Inventory management
// FTCR Module
import FtcrModule from "ftcr/FtcrModule.jsx";
// Refund module
import RefundModuleDashboard from "components/RefundModule/RefundModuleDashboard.jsx";
import RefundSummary from "components/RefundModule/RefundSummary.jsx";
import TxnSummary from "components/RefundModule/TxnSummary.jsx";
import TicketDetailsWithAgeing from "components/SupportModule/TicketDetailsWithAgeing.jsx";

import AsoAttendanceReport from "components/SupportModule/AsoAttendanceReport.jsx";
import LinkPKYCReport from "components/SupportModule/LinkPKYCReport.jsx";
import BeatPlanReport from "components/SupportModule/BeatPlanReport.jsx";

import CrispReport from "reports/CrispReport.jsx";
var allRoutes=[];
if (isMobile) {
    allRoutes = [
        {
            path: "/reports",
            name: "UnipayNext",
            menu_per: "headrun_reports",
            icon: "pe-7s-news-paper",
            component: "",
            layout: "/admin",
            isDrop: true,
            submenus: [
                {
                    path: "/dashboard",
                    name: "Dashboard",
                    menu_per: "dashboard_view",
                    icon: "pe-7s-graph3",
                    component: DashboardList,
                    layout: "/admin",
                    isDrop: false,
                    dis_order: 0
                },
                {
                    path: "/emi-report",
                    name: "EMI Report",
                    icon: "pe-7s-box1",
                    component: EmiReport,
                    layout: "/admin",
                    menu_per: "emi_scheme",
                    dis_order: 1
                },
                {
                    path: "/sale",
                    name: "Sale Report",
                    icon: "pe-7s-display1",
                    component: Sale,
                    layout: "/admin",
                    menu_per: "sales_reports",
                    dis_order: 2
                },
                {
                    path: "/transaction-report",
                    name: "Transaction Report",
                    icon: "pe-7s-news-paper",
                    component: TransactionReport,
                    layout: "/admin",
                    menu_per: "transaction_reports",
                    dis_order: 3
                },
                {
                    path: "/settlement",
                    name: "Settlement Report",
                    icon: "pe-7s-diskette",
                    component: SettlementReport,
                    layout: "/admin",
                    menu_per: "settlement_reports",
                    dis_order: 4
                },
                {
                    path: "/acquirer-report",
                    name: "Acquirer Report",
                    icon: "pe-7s-graph",
                    component: AcquirerReport,
                    layout: "/admin",
                    menu_per: "acquirer_reports",
                    dis_order: 6
                },
                {
                    path: "/support-module",
                    name: "Support Module",
                    icon: "pe-7s-plugin",
                    component: Support,
                    layout: "/admin",
                    menu_per: "support_module",
                    dis_order: 7
                },

                {
                    path: "/transaction-report-history",
                    name: "Historical Data",
                    icon: "pe-7s-cloud-download",
                    component: FlatFiles,
                    layout: "/admin",
                    menu_per: "flat_files",
                    dis_order: 8
                },

            ]
        },
        {
            path: "/totalemi",
            name: "Total EMI",
            menu_per: "totalemi",
            icon: "pe-7s-graph1",
            component: "",
            layout: "/admin",
            isDrop: true,
            submenus: [
                {
                    path: "/totalemi-dashboard",
                    name: "Dashboard",
                    icon: "fa fa-dashboard",
                    component: IposDashboard,
                    layout: "/admin",
                    menu_per: "totalemi_dashboard",
                    dis_order: 1,
                },
                {
                    path: "/totalemi-trends",
                    name: "Trends",
                    icon: "fa fa-bar-chart",
                    component: IposTrends,
                    layout: "/admin",
                    menu_per: "totalemi_trends",
                    dis_order: 2,
                },
                {
                    path: "/totalemi-tools",
                    name: "Tools",
                    icon: "fa fa-calculator",
                    component: IposTools,
                    layout: "/admin",
                    menu_per: "totalemi_tools",
                    dis_order: 3,
                },
                {
                    path: "/totalemi-help",
                    name: "Help",
                    icon: "fa fa-question-circle",
                    component: IposHelp,
                    layout: "/admin",
                    menu_per: "totalemi_help",
                    dis_order: 4,
                },
                {
                    path: "/totalemi-profile",
                    name: "Profile",
                    icon: "fa fa-user",
                    component: IposProfile,
                    layout: "/admin",
                    menu_per: "totalemi_profile",
                    dis_order: 5,
                },
            ],
        },
        {
            path: "#",
            name: "SRO Support",
            menu_per: "Customer_Support",
            icon: "pe-7s-print",
            component: "",
            layout: "/admin",
            isDrop: true,
            submenus: [
                {
                    path: "/Innoviti-Support-Modes",
                    name: "SRO",
                    menu_per: "Innoviti_Support_Modes",
                    icon: "pe-7s-credit",
                    component: InnovitiSupportModes,
                    layout: "/admin",
                    dis_order: 5
                },
            ]
        },
    ];
} else {
    allRoutes = [

        {
            path: "/reports",
            name: "UnipayNext",
            menu_per: "headrun_reports",
            icon: "pe-7s-news-paper",
            component: "",
            layout: "/admin",
            isDrop: true,
            submenus: [
                {
                    path: "/dashboard",
                    name: "Dashboard",
                    menu_per: "dashboard_view",
                    icon: "pe-7s-graph3",
                    component: DashboardList,
                    layout: "/admin",
                    isDrop: false,
                    dis_order: 0
                },
                {
                    path: "/emi-report",
                    name: "EMI Report",
                    icon: "pe-7s-box1",
                    component: EmiReport,
                    layout: "/admin",
                    menu_per: "emi_scheme",
                    dis_order: 1
                },
                {
                    path: "/sale",
                    name: "Sale Report",
                    icon: "pe-7s-display1",
                    component: Sale,
                    layout: "/admin",
                    menu_per: "sales_reports",
                    dis_order: 2
                },
                {
                    path: "/transaction-report",
                    name: "Transaction Report",
                    icon: "pe-7s-news-paper",
                    component: TransactionReport,
                    layout: "/admin",
                    menu_per: "transaction_reports",
                    dis_order: 3
                },
                {
                    path: "/settlement",
                    name: "Settlement Report",
                    icon: "pe-7s-diskette",
                    component: SettlementReport,
                    layout: "/admin",
                    menu_per: "settlement_reports",
                    dis_order: 4
                },
                {
                    path: "/acquirer-report",
                    name: "Acquirer Report",
                    icon: "pe-7s-graph",
                    component: AcquirerReport,
                    layout: "/admin",
                    menu_per: "acquirer_reports",
                    dis_order: 6
                },
                {
                    path: "/support-module",
                    name: "Support Module",
                    icon: "pe-7s-plugin",
                    component: Support,
                    layout: "/admin",
                    menu_per: "support_module",
                    dis_order: 7
                },
                {
                    path: "/transaction-report-history",
                    name: "Historical Data",
                    icon: "pe-7s-cloud-download",
                    component: FlatFiles,
                    layout: "/admin",
                    menu_per: "flat_files",
                    dis_order: 8
                },
                {
                    path: "/invoice",
                    name: "Invoice",
                    icon: "pe-7s-print",
                    component: AdminInvoice,
                    layout: "/admin",
                    menu_per: "admin_invoice",
                    dis_order: 9
                },
                {
                    path: "/adani-gas-station-daily-report",
                    name: "Adani Gas Station Reports",
                    icon: "pe-7s-print",
                    component: AdaniGasStationDailyReport,
                    layout: "/admin",
                    menu_per: "adani_gas_station_report",
                    dis_order: 9
                },

            ]
        },
        {
            path: "/internal-reports",
            name: "Internal Tools",
            menu_per: "internal_report",
            icon: "pe-7s-albums",
            component: InternalReport,
            layout: "/admin",
            isDrop: false,
            submenus: []
        },
        {
            path: "/any-card-EMI",
            name: "Any Card EMI",
            menu_per: "any_card_emi",
            icon: "pe-7s-next-2",
            component: AnyCardEmi,
            layout: "/admin",
            isDrop: false,
            submenus: []
        },
        {
            path: "#",
            name: "Brand EMI",
            menu_per: "brand_emi_menu",
            icon: "pe-7s-credit",
            component: "",
            layout: "/admin",
            isDrop: true,
            submenus: [
                {
                    path: "/brand-emi",
                    name: "Configuration",
                    menu_per: "promotion_portal",
                    icon: "pe-7s-home",
                    component: BrandEMIAdmin,
                    layout: "/admin",
                    isDrop: false,
                    submenus: [],
                    dis_order: 0
                },
                {
                    path: "/onboarding",
                    name: "Brand Onboarding",
                    menu_per: "brand_onboarding",
                    icon: "pe-7s-global",
                    component: Onboarding,
                    layout: "/admin",
                    isDrop: false,
                    submenus: [],
                },
                {
                    path: "/brand-emi-reports",
                    name: "Brand Txn Report",
                    menu_per: "brand_emi_reports",
                    icon: "pe-7s-cash",
                    component: BrandEmiReport,
                    layout: "/admin",
                    isDrop: false,
                    submenus: []
                },
                {
                    path: "/communication",
                    name: "Communication",
                    menu_per: "brand_emi_communication",
                    icon: "pe-7s-cash",
                    component: Communication,
                    layout: "/admin",
                    isDrop: false,
                    submenus: []
                }

            ],
            //dis_order: 1
        },
        {
            path: "#",
            name: "Refund Module",
            menu_per: "refund_module",
            icon: "pe-7s-credit",
            component: "",
            layout: "/admin",
            isDrop: true,
            submenus: [
                {
                    path: "/refund-module-dashboard",
                    name: "Dashboard",
                    menu_per: "refund_dashboard",
                    icon: "pe-7s-graph3",
                    component: RefundModuleDashboard,
                    layout: "/admin",
                    isDrop: false,
                    submenus: [],
                    dis_order: 0
                },
                {
                    path: "/re-txn-summary",
                    name: "Transaction Summary",
                    menu_per: "refund_txn_summary",
                    icon: "pe-7s-news-paper",
                    component: TxnSummary,
                    layout: "/admin",
                    isDrop: false,
                    submenus: [],
                },
                {
                    path: "/refund-summary",
                    name: "Refund Summary",
                    menu_per: "refund_summary",
                    icon: "pe-7s-cash",
                    component: RefundSummary,
                    layout: "/admin",
                    isDrop: false,
                    submenus: []
                }
//                {
//                    path: "/communication",
//                    name: "Chargeback Management",
//                    menu_per: "chargeback_mgt",
//                    icon: "pe-7s-cash",
//                    component: Communication,
//                    layout: "/admin",
//                    isDrop: false,
//                    submenus: []
//                }

            ],
            //dis_order: 1
        },
        {
            path: "#",
            name: "DIY Integration",
            menu_per: "diy_integration",
            icon: "pe-7s-helm",
            component: "",
            layout: "/admin",
            isDrop: true,
            submenus: [
                {
                    path: "/Home",
                    name: "Get Started",
                    menu_per: "get_started",
                    icon: "pe-7s-home",
                    component: Home,
                    layout: "/admin",
                    isDrop: false,
                    submenus: []
                },
                {
                    path: "/ApiDoc",
                    name: "API Documentation",
                    menu_per: "api_documentation",
                    icon: "pe-7s-global",
                    component: ApiHome,
                    layout: "/admin",
                    isDrop: true,
                    submenus: [
                    ]
                },
                {
                    path: "/IntegrationKey",
                    name: "Key Management",
                    menu_per: "integration_key",
                    icon: "pe-7s-key",
                    component: IntegrationKey,
                    layout: "/admin",
                    isDrop: false,
                    submenus: []
                },
                {
                    path: "/TerminalSimulator",
                    name: "Terminal Simulator",
                    menu_per: "terminal_simulator",
                    icon: "pe-7s-phone",
                    component: TerminalSimulator,
                    layout: "/admin",
                    isDrop: false,
                    submenus: []
                },
                {
                    path: "/DiyTransactionReport",
                    name: "Transaction Report",
                    menu_per: "diy_transaction_report",
                    icon: "pe-7s-global",
                    component: DiyTransactionReport,
                    layout: "/admin",
                    isDrop: false,
                    submenus: []
                },
                /* {
                     path: "/TestWizard",
                     name: "Test Wizard",
                     menu_per: "TestWizard",
                     icon: "pe-7s-keypad",
                     component: TestWizard,
                     layout: "/admin",
                     isDrop: false,
                     submenus:[]
                 }, */
            ]
        },
        {
            path: "#",
            name: "Inventory",
            menu_per: "inventory",
            icon: "pe-7s-print",
            component: "",
            layout: "/admin",
            isDrop: true,
            submenus: [
                {
                    path: "/manage-stocks",
                    name: "Manage Stock",
                    menu_per: "manage_stocks",
                    icon: "pe-7s-credit",
                    component: ManageStock,
                    layout: "/admin",
                    dis_order: 1
                },
                {
                    path: "/orders",
                    name: "Order",
                    menu_per: "order_details",
                    icon: "pe-7s-credit",
                    component: Order,
                    layout: "/admin",
                    dis_order: 2
                },
                {
                    path: "/assets",
                    name: "Asset",
                    menu_per: "assets_detail",
                    icon: "pe-7s-credit",
                    component: Asset,
                    layout: "/admin",
                    dis_order: 3
                },
                {
                    path: "/consumables",
                    name: "Consumable",
                    menu_per: "consumables_detail",
                    icon: "pe-7s-credit",
                    component: Consumable,
                    layout: "/admin",
                    dis_order: 4
                },
                {
                    path: "/OrderPlacement",
                    name: "Order Placement Form",
                    menu_per: "order_placement",
                    icon: "pe-7s-credit",
                    component: OrderPlacement,
                    layout: "/admin",
                    dis_order: 5
                },
                {
                    path: "/DisputeForm",
                    name: "Raise Dispute",
                    menu_per: "Raise_Dispute",
                    icon: "pe-7s-credit",
                    component: DisputeForm,
                    layout: "/admin",
                    dis_order: 6
                },
                {
                    path: "/tvsManageStock",
                    name: "Manage Stock",
                    menu_per: "tvs_ManageStock",
                    icon: "pe-7s-credit",
                    component: tvsStock,
                    layout: "/admin",
                    dis_order: 7
                },
                {
                    path: "/tvsOrder",
                    name: "Order",
                    menu_per: "tvs_Order",
                    icon: "pe-7s-credit",
                    component: tvsOrder,
                    layout: "/admin",
                    dis_order: 8
                },
                {
                    path: "/tvsAsset",
                    name: "Asset",
                    menu_per: "tvs_Asset",
                    icon: "pe-7s-credit",
                    component: tvsAsset,
                    layout: "/admin",
                    dis_order: 9
                }
            ]
        },
        {
            path: "/totalemi",
            name: "Total EMI",
            menu_per: "totalemi",
            icon: "pe-7s-graph1",
            component: "",
            layout: "/admin",
            isDrop: true,
            submenus: [
                {
                    path: "/totalemi-dashboard",
                    name: "Dashboard",
                    icon: "fa fa-dashboard",
                    component: IposDashboard,
                    layout: "/admin",
                    menu_per: "totalemi_dashboard",
                    dis_order: 1,
                },
                {
                    path: "/totalemi-trends",
                    name: "Trends",
                    icon: "fa fa-bar-chart",
                    component: IposTrends,
                    layout: "/admin",
                    menu_per: "totalemi_trends",
                    dis_order: 2,
                },
                {
                    path: "/totalemi-tools",
                    name: "Tools",
                    icon: "fa fa-calculator",
                    component: IposTools,
                    layout: "/admin",
                    menu_per: "totalemi_tools",
                    dis_order: 3,
                },
                {
                    path: "/totalemi-help",
                    name: "Help",
                    icon: "fa fa-question-circle",
                    component: IposHelp,
                    layout: "/admin",
                    menu_per: "totalemi_help",
                    dis_order: 4,
                },
                {
                    path: "/totalemi-profile",
                    name: "Profile",
                    icon: "fa fa-user",
                    component: IposProfile,
                    layout: "/admin",
                    menu_per: "totalemi_profile",
                    dis_order: 5,
                },
            ],
        },


        /*  {
           path: "/brandemi",
           name: "Brand EMI",
           menu_per: "brandemi",
           icon: "pe-7s-graph",
           component: "",
           layout: "/admin",
           isDrop: true,
           submenus: [
             {
               path: "/brandemi-dashboard",
               name: "Dashboard",
               icon: "",
               component: BrandDashboard,
               layout: "/admin",
               menu_per: "brandemi_dashboard",
               dis_order: 1,
             },
             {
               path: "/brandemi-trends",
               name: "Trends",
               icon: "",
               component: BrandTrends,
               layout: "/admin",
               menu_per: "brandemi_trends",
               dis_order: 2,
             },
             {
               path: "/brandemi-tools",
               name: "Tools",
               icon: "",
               component: BrandTools,
               layout: "/admin",
               menu_per: "brandemi_tools",
               dis_order: 3,
             },
             {
               path: "/brandemi-help",
               name: "Help",
               icon: "",
               component: BrandHelp,
               layout: "/admin",
               menu_per: "brandemi_help",
               dis_order: 4,
             },
             {
               path: "/brandemi-profile",
               name: "Profile",
               icon: "",
               component: BrandProfile,
               layout: "/admin",
               menu_per: "brandemi_profile",
               dis_order: 5,
             },
           ],
               }, */
        {
            path: "/ftcr-module",
            name: "FTCR",
            menu_per: "ftcr_module",
            icon: "pe-7s-drawer",
            component: FtcrModule,
            layout: "/admin",
            isDrop: false,
            submenus: []
        },
        {
            path: "#",
            name: "Nirdharan",
            menu_per: "nirdharan_menu",
            icon: "pe-7s-ticket",
            component: "",
            layout: "/admin",
            isDrop: true,
            submenus: [
                {
                    path: "/ticket-details-with-ageing",
                    name: "Urgent tickets assignment",
                    menu_per: "ticket_details_with_ageing",
                    icon: "pe-7s-users",
                    component: TicketDetailsWithAgeing,
                    layout: "/admin",
                    dis_order: 1
                    // isDrop: false,
                    // submenus:[]
                },
                {
                    path: "/beat-plan-report",
                    name: "Beat Plan Report",
                    menu_per: "beat_plan_report",
                    icon: "pe-7s-users",
                    component: BeatPlanReport,
                    layout: "/admin",
                    dis_order: 1
                    // isDrop: false,
                    // submenus:[]
                },
                {
                    path: "/aso-attendance-report",
                    name: "ASO attendance report",
                    menu_per: "aso_attendance_reports",
                    icon: "pe-7s-users",
                    component: AsoAttendanceReport,
                    layout: "/admin",
                    dis_order: 1
                    // isDrop: false,
                    // submenus:[]
                },

            ]
        },

        {
            path: "#",
            name: "Tableau",
            menu_per: "tableau_menu",
            icon: "pe-7s-graph1",
            component: "",
            layout: "/admin",
            isDrop: true,
            submenus: [
                {
                    path: "/tableau-settings",
                    name: "Settings",
                    menu_per: "tableau_settings",
                    icon: "pe-7s-users",
                    component: TableauSettings,
                    layout: "/admin",
                    dis_order: 1
                    // isDrop: false,
                    // submenus:[]
                },
                {
                    path: "/tableau-data-mgt",
                    name: "Tableau Data Mgt",
                    menu_per: "tableau_data_mgt",
                    icon: "pe-7s-users",
                    component: TableauDataMgt,
                    layout: "/admin",
                    dis_order: 1
                    // isDrop: false,
                    // submenus:[]
                },
                {
                    path: "/tableau-project",
                    name: "Tableau Reports",
                    menu_per: "tableau_project",
                    icon: "pe-7s-users",
                    component: TableauProject,
                    layout: "/admin",
                    dis_order: 1
                    // isDrop: false,
                    // submenus:[]
                },

            ]
        },

        {
            path: "#",
            name: "Admin",
            menu_per: "admin_menu",
            icon: "pe-7s-user",
            component: "",
            layout: "/admin",
            isDrop: true,
            submenus: [
                {
                    path: "/users",
                    name: "User Administration",
                    menu_per: "user_administration",
                    icon: "pe-7s-users",
                    component: UserList,
                    layout: "/admin",
                    dis_order: 1
                    // isDrop: false,
                    // submenus:[]
                },
                {
                    path: "/upload-excel",
                    name: "UploadExcel",
                    menu_per: "admin_upload_excel",
                    icon: "pe-7s-cloud-upload",
                    component: UploadExcel,
                    layout: "/admin",
                    dis_order: 2
                    // isDrop: false,
                    // submenus:[]
                },
                {
                    path: "/audit-log",
                    name: "Process Log",
                    menu_per: "audit_log",
                    icon: "pe-7s-note2",
                    component: AuditLog,
                    layout: "/admin",
                    dis_order: 3
                    // isDrop: false,
                    // submenus:[]
                },
                {
                    path: "/ssis-process-logs",
                    name: "SSIS Process Logs",
                    menu_per: "ssis_process_logs",
                    icon: "pe-7s-cloud-upload",
                    component: SSISProcessLogs,
                    layout: "/admin",
                    dis_order: 6
                    // isDrop: false,
                    // submenus:[]
                },
                {
                    path: "/job-management",
                    name: "Job Management",
                    menu_per: "job_management",
                    icon: "pe-7s-users",
                    component: JobMgt,
                    layout: "/admin",
                    dis_order: 4
                    // isDrop: false,
                    // submenus:[]
                },
                {
                    path: "/tableau-report-access",
                    name: "Tableau Access Permission",
                    menu_per: "tableau_access_permission",
                    icon: "pe-7s-users",
                    component: TableauReportAccessPermission,
                    layout: "/admin",
                    dis_order: 4
                    // isDrop: false,
                    // submenus:[]
                },
                {
                    path: "/axis-aggr-master",
                    name: "Axis Aggr Master",
                    menu_per: "axis_aggr_master",
                    icon: "pe-7s-users",
                    component: AxisAggrMaster,
                    layout: "/admin",
                    dis_order: 5
                    // isDrop: false,
                    // submenus:[]
                },
                {
                    path: "",
                    name: "Log",
                    menu_per: "view_logs",
                    icon: "pe-7s-note2",
                    component: AuditLog,
                    layout: "newtab",
                    dis_order: 6
                    // isDrop: false,
                    // submenus:[]
                }


            ]
        },

        {
            path: "#",
            name: "SRO Support",
            menu_per: "Customer_Support",
            icon: "pe-7s-print",
            component: "",
            layout: "/admin",
            isDrop: true,
            submenus: [
                // {
                //     path: "/Create-Support-Ticket",
                //     name: "Create Support Ticket",
                //     menu_per: "Create_Support_Ticket",
                //     icon: "pe-7s-credit",
                //     component: CreateSupportTicket,
                //     layout: "/admin",
                //     dis_order: 1
                // },
                // {
                //     path: "/View-Ticket-Status",
                //     name: "View Ticket Status",
                //     menu_per: "View_Ticket_Status",
                //     icon: "pe-7s-credit",
                //     component: ViewTicketStatus,
                //     layout: "/admin",
                //     dis_order: 2
                // },
                // {
                //     path: "/Support-Ticket-Summary",
                //     name: "Support Ticket Summary",
                //     menu_per: "Support_Ticket_Summary",
                //     icon: "pe-7s-credit",
                //     component: SupportTicketSummary,
                //     layout: "/admin",
                //     dis_order: 4
                // },
                {
                    path: "/Innoviti-Support-Modes",
                    name: "SRO",
                    menu_per: "Innoviti_Support_Modes",
                    icon: "pe-7s-credit",
                    component: InnovitiSupportModes,
                    layout: "/admin",
                    dis_order: 5
                },
            ]
        },
        {
            path: "/lounge-project",
            name: "Lounge Dashboard",
            menu_per: "lounge_module",
            icon: "pe-7s-graph3",
            component: LoungeProject,
            layout: "/admin",
            isDrop: false,
            submenus: []
        },
        {
            path: "/lounge-projects",
            name: "Lounge Dashboard",
            menu_per: "lounge_modules",
            icon: "pe-7s-graph3",
            component: LoungeProject1,
            layout: "/admin",
            isDrop: false,
            submenus: []
        },
        {
            path: "/dms-project",
            name: "DMS Dashboard",
            menu_per: "dms_module",
            icon: "pe-7s-graph3",
            component: DmsProject,
            layout: "/admin",
            isDrop: false,
            submenus: []
        },
        {
            path: "/campaign-lists",
            name: "Campaign Catalogue",
            menu_per: "campaign_lists",
            icon: "pe-7s-share",
            component: CampaignLists,
            layout: "/admin",
            isDrop: false,
            submenus: []
        },
        {
            path: "/crisp-reports",
            name: "CRISP",
            menu_per: "CRISP_report",
            icon: "pe-7s-shield",
            component: CrispReport,
            layout: "/admin",
            isDrop: false,
            submenus: []
        },
    ];
}


export default allRoutes;

